export default __webpack_public_path__ + "static/media/3031 spice rack E side.f78d6c02.png";